/**
 * Convert UI operator to backend operator on submission.
 * When bottom selection is empty, converts value-requiring operators to 'skip'.
 *
 * Conversions (when bottomSelectionEmpty is true):
 * - 'any' (text: "any of these") → 'skip' (text: "any")
 * - 'none' (text: "none of these") → 'skip' (text: "any")
 * - 'all' (text: "all of these") → 'skip' (text: "any")
 *
 * When bottomSelectionEmpty is false, returns operator unchanged.
 */
const toBackendOperator = (
  operator: string,
  bottomSelectionEmpty: boolean
): string => {
  if (!bottomSelectionEmpty) {
    return operator
  }

  switch (operator) {
    case 'any':
    case 'none':
    case 'all':
      return 'skip'
    default:
      return operator
  }
}

export default toBackendOperator
